<template>
  <div class="paymentCard" v-if="!isCheckPayment">
    <p class="paymentHeadText">Оплата</p>

    <div class="paymentInputs" v-if="paymentData">
      <!-- TP: реквизиты не выдаются, оплата проходит через техподдержку -->
      <div v-if="paymentData.payment.type == 'tp'" style="display: flex; flex-direction: column; gap: 10px">
        <p>К оплате</p>
        <input type="text" :value="paymentData.payment.amount + ' рублей'" readonly />
        <p>Способ</p>
        <input type="text" :value="paymentData.payment.details.bank_name" readonly />
        <p class="tpPaymentHint">
          Оплата этого заказа производится через техподдержку. Напишите оператору, чтобы завершить
          платёж.
        </p>
        <button class="checkPayment" @click="supportClick">Написать в поддержку</button>
      </div>
      <div
        v-else-if="paymentData.payment.type == 'sbp'"
        style="display: flex; flex-direction: column; gap: 10px"
      >
        <a :href="paymentData.payment.details.sbp_link" target="_blank" style="margin: 0 auto">
          <img :src="qrSrc" class="qr_img" />
        </a>
        <p>К оплате</p>
        <input type="text" :value="paymentData.payment.amount + ' рублей'" readonly />
      </div>
      <div class="typePayment" v-else-if="paymentData.payment.type.slice(0, 4) != 'card'">
        <p>К оплате</p>
        <input type="text" :value="paymentData.payment.details.summ_pay + ' ' + paymentData.payment.type.toUpperCase()" readonly />
        <p>Адрес получателя</p>
        <div class="bankInput" @click="copyCard">
          <input type="text" :value="paymentData.payment.details.number ? paymentData.payment.details.number : 1" readonly style="padding-right: 15%" />
          <img src="../assets/icons/paymentMethods/copy.svg" style="cursor: pointer" />
        </div>
      </div>
      <div v-else style="display: flex; flex-direction: column; gap: 10px">
        <p>К оплате</p>
        <input type="text" :value="paymentData.payment.amount + ' рублей'" readonly />
        <p v-if="paymentData.payment.details.bank_name && paymentData.payment.details.bank_name.length > 4">Банк</p>
        <input type="text" v-if="paymentData.payment.details.bank_name && paymentData.payment.details.bank_name.length > 4" :value="paymentData.payment.details.bank_name" readonly />
        <p>Номер банка для перевода</p>
        <div class="bankInput" @click="copyCard">
          <input type="text" :value="paymentData.payment.details.card" readonly v-if="paymentData.payment.details.card && paymentData.payment.details.card.length > 5" />
          <input type="text" :value="paymentData.payment.details.number" readonly v-else />
          <img src="../assets/icons/paymentMethods/copy.svg" style="cursor: pointer" />
        </div>
        <p v-if="paymentData.payment.details.fio_card.length > 5">Имя получателя</p>
        <input type="text" v-if="paymentData.payment.details.fio_card.length > 5" :value="paymentData.payment.details.fio_card" readonly />
      </div>
      <!-- {{ paymentData.payment }} -->
      <button class="checkPayment" @click="checkPayment">Проверить статус перевода</button>
    </div>
  </div>
  <div class="checkPaymentCard" v-else>
    <div class="backArrow" v-if="paymentStatus == 'error'">
      <img src="../assets/icons/arrowLeft.svg" />
      <p @click="goBack">Назад</p>
    </div>
    <div class="statusBlock">
      <LoadingAnimation v-if="paymentStatus == 'loading'" />
      <img src="../assets/icons/paymentMethods/successfulPayment.svg" v-if="paymentStatus == 'success'" />
      <img src="../assets/icons/paymentMethods/errorPayment.svg" v-if="paymentStatus == 'error'" />
      <!-- v-if='paymentStatus == "success"' -->
    </div>
    <p class="paymentInfoText">{{ paymentStatusText }}</p>

    <div class="writeUsBlock">
      <p class="writeUsBottomText">
        Для уточнения деталей заказа<br />
        свяжитесь с технической поддержкой
      </p>
      <button class="writeUsButton" @click="supportClick">
        <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.05976 7.45445C1.10459 7.43203 1.14944 7.41073 1.19315 7.39055C1.95304 7.03852 2.72302 6.70891 3.49188 6.3793C3.53335 6.3793 3.60282 6.3311 3.64205 6.3154C3.70145 6.28961 3.76086 6.26495 3.82026 6.23916L4.16211 6.0923C4.39075 5.99476 4.61825 5.89722 4.84689 5.79969C5.30305 5.60461 5.75921 5.40954 6.21537 5.21334C7.12769 4.8232 8.04115 4.43193 8.95347 4.04178C9.86579 3.65163 10.7792 3.26036 11.6915 2.87021C12.6039 2.48006 13.5173 2.0888 14.4296 1.69865C15.3419 1.3085 16.2554 0.917229 17.1677 0.527081C17.3706 0.439634 17.5902 0.309585 17.8077 0.271467C17.9904 0.238954 18.1686 0.176172 18.3524 0.141418C18.7009 0.0752718 19.0854 0.048365 19.4193 0.192989C19.5348 0.243439 19.6413 0.314069 19.7298 0.402637C20.1535 0.821934 20.0941 1.5103 20.0044 2.10001C19.3801 6.21001 18.7558 10.3211 18.1304 14.4312C18.0453 14.9951 17.9287 15.6139 17.4837 15.9704C17.1072 16.272 16.5714 16.3057 16.1063 16.1779C15.6412 16.0489 15.231 15.7787 14.8286 15.513C13.1598 14.4076 11.4898 13.3022 9.82096 12.1968C9.4242 11.9344 8.98261 11.5914 8.9871 11.1149C8.98934 10.8279 9.1608 10.5723 9.33565 10.3447C10.7859 8.45225 12.8784 7.15175 14.4352 5.34676C14.6549 5.09226 14.8275 4.63261 14.526 4.48574C14.3467 4.39829 14.1404 4.51713 13.9768 4.63036C11.919 6.05979 9.86242 7.49033 7.80466 8.91975C7.13331 9.38614 6.42946 9.86597 5.62025 9.98033C4.89623 10.0835 4.16772 9.88167 3.46723 9.67538C2.87994 9.50273 2.29375 9.3256 1.70982 9.14285C1.39936 9.04644 1.07881 8.94217 0.838964 8.72356C0.599116 8.50494 0.461278 8.13721 0.60586 7.84572C0.696643 7.66298 0.87261 7.54751 1.05754 7.45333L1.05976 7.45445Z"
            fill="#FEFFFC"
          />
        </svg>
        <p>Написать</p>
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import LoadingAnimation from "./LoadingAnimation.vue";
import { openChatWidget } from "@/utils/chatWidget";
export default {
  name: "PaymentCard",
  data() {
    return {
      paymentSum: "",
      paymentBank: "",
      paymentCard: "",
      paymentRecipient: "",
      paymentStatus: "loading",
      paymentStatusText: "Оплата в процессе",
      isCheckPayment: false,
    };
  },
  methods: {
    checkPayment() {
      let img = document.querySelector(".modalHeader img");
      let cross = document.querySelector(".closeAuth");
      img.style.opacity = "1";
      cross.style.opacity = "0";
      this.paymentStatus = "loading";
      this.paymentStatusText = "Оплата в процессе";
      this.isCheckPayment = true;
      console.log(this.paymentData);
      axios
        .put(
          `https://${process.env.VUE_APP_SERVERHOST}/api/order/${this.paymentData._id}`,
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.userData.token,
            },
          },
        )
        .then((res) => {
          setTimeout(() => {
            cross.style.opacity = "1";
            document.querySelector(".closeAuth").style.display = "flex";
            if (res.data.result.status == "SUCCESS") {
              this.paymentStatus = "success";
              this.paymentStatusText = "Оплата прошла успешно!";
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            } else {
              this.paymentStatus = "error";
              this.paymentStatusText = "Оплата не прошла! Попробуйте ещё раз!";
            }
          }, 2000);
          console.log(res);
        })
        .catch((err) => {
          setTimeout(() => {
            cross.style.opacity = "1";
            this.paymentStatus = "error";
            document.querySelector(".closeAuth").style.display = "flex";
            this.paymentStatusText = "Произошла ошибка!";
            setTimeout(() => {
              this.isCheckPayment = false;
            }, 2000);
          }, 2000);
          this.toast.error(err.response.data.message);
          console.log(err);
        });
    },
    copyCard() {
      let inp = document.querySelector(".bankInput input");
      navigator.clipboard.writeText(inp.value);
      this.toast.success("Поле успешно скопировано!");
    },
    supportClick() {
      openChatWidget();
    },
    goBack() {
      this.isCheckPayment = false;
    },
  },
  props: {
    paymentData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  computed: {
    qrSrc() {
      return `data:image/png;base64,${this.paymentData.payment.details.sbp_qr}`;
    },
  },
  mounted() {
    console.log(this.paymentData);
  },
  components: {
    LoadingAnimation,
  },
};
</script>

<style scoped>
.paymentCard {
  margin-bottom: 3%;
}
.paymentHeadText {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
}
.paymentInputs p {
  color: #333333;
  font-size: 14px;
}
.typePayment {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.paymentInputs {
  margin-top: 5%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bankInput {
  display: flex;
  position: relative;
  cursor: pointer;
}
.bankInput input {
  cursor: pointer;
}
.bankInput img {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.tpPaymentHint {
  color: #7a7a7a !important;
  font-size: 13px !important;
  line-height: 1.5;
}
.checkPayment {
  width: 100%;
  border-radius: 10px;
  background: #ff8989;
  border: 1px solid #ff8989;
  color: white;
  font-weight: 600;
  padding: 14px;
  cursor: pointer;
}
.checkPaymentCard {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* padding-top: 5%; */
  padding-bottom: 5%;
}
.backArrow {
  color: #333333;
  width: 100%;
  display: flex;
  gap: 5px;
  font-size: 14px;
  font-weight: 600;
}
.backArrow img,
.backArrow p {
  cursor: pointer;
}
.statusBlock {
  width: 30%;
  height: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paymentInfoText {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  margin-top: 8%;
  margin-bottom: 15%;
  text-align: center;
}
.writeUsBlock {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.writeUsBottomText {
  font-size: 14px;
  color: #333333;
}
.writeUsButton {
  background-color: #ff8989;
  border-radius: 50px;
  border: 1px solid #ff8989;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  padding: 10px 20px 10px 20px;
  cursor: pointer;
}
input {
  outline: none;
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #d8dadc;
  padding: 12px 15px 12px 15px;
  width: 100%;

  color: #333333;
}
.qr_img {
  width: 15vw;
}
.qr_img {
  transition: transform 0.2s ease-in-out;
}
.qr_img:hover {
  transform: scale(1.05);
}
@media (max-width: 768px) {
  .qr_img {
    width: 60vw;
  }
}
</style>
